import { Component, Prop, h } from "@stencil/core";
import classNames from "classnames";

@Component({
  tag: "f-flyout-feature-bar",
  styleUrl: "f-flyout-feature-bar.scss",
  shadow: true,
})
export class FlyoutFeatureBar {
  @Prop() variant: "single" | "group" = "single";
  @Prop() label: string;
  @Prop() link: string;

  render() {
    const cssClass = classNames("flyout-feature-bar", {
      [`flyout-feature-bar--${this.variant}`]: this.variant,
    });

    return (
      <div
        class={cssClass}
        data-test="flyout-feature-bar"
        part="scheme-secondary"
      >
        {this.variant === "single" ? (
          <div
            class="flyout-feature-bar__inner"
            data-test="flyout-feature-content"
          >
            <slot name="feature-bar-content" />
          </div>
        ) : (
          ""
        )}
        {this.variant === "group" ? (
          <div class="flyout-feature-bar__inner">
            <div
              class="flyout-feature-bar__group"
              data-test="flyout-feature-group"
            >
              <div
                class="flyout-feature-bar__group__part-1"
                data-test="flyout-feature-group-part1"
              >
                <slot name="feature-bar-group-main" />
              </div>
              <div
                class="flyout-feature-bar__group__part-2"
                data-test="flyout-feature-group-part2"
              >
                <slot name="feature-bar-group-btn" />
              </div>
            </div>
          </div>
        ) : (
          ""
        )}
      </div>
    );
  }
}
